import { render, staticRenderFns } from "./OrteMapCard.vue?vue&type=template&id=7bad50e4&scoped=true&"
import script from "./OrteMapCard.vue?vue&type=script&lang=js&"
export * from "./OrteMapCard.vue?vue&type=script&lang=js&"
import style0 from "./OrteMapCard.vue?vue&type=style&index=0&id=7bad50e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad50e4",
  null
  
)

export default component.exports